import script from "./FilePreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilePreview.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
